// src/components/LoadingScreen.js
import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';

function LoadingScreen({ onLoadComplete }) {
  const [progress, setProgress] = useState(0);
  const [currentTip, setCurrentTip] = useState(0);

  const tips = [
    'Streamline your community management',
    'Pay maintenance fees online',
    'Track visitor entries easily',
    'Book amenities instantly',
    'Stay connected with neighbors'
  ];

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          if (onLoadComplete) {
            setTimeout(onLoadComplete, 300);
          }
          return 100;
        }
        const increment = prev < 30 ? 10 : prev < 80 ? 5 : 2;
        return Math.min(prev + increment, 100);
      });
    }, 100);

    const tipInterval = setInterval(() => {
      setCurrentTip(prev => (prev + 1) % tips.length);
    }, 6000);

    return () => {
      clearInterval(progressInterval);
      clearInterval(tipInterval);
    };
  }, [onLoadComplete]);

  return (
    <div className="loading-screen">
      <div className="loading-pattern"></div>
      
      <div className="loading-content">
        {/* Building Animation */}
        <div className="building-animation">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <rect x="15" y="25" width="50" height="45" fill="#ffffff" opacity="0.9"/>
            <rect x="20" y="30" width="10" height="10" fill="#3b82f6" className="window" style={{'--window-index': 0}}/>
            <rect x="35" y="30" width="10" height="10" fill="#3b82f6" className="window" style={{'--window-index': 1}}/>
            <rect x="50" y="30" width="10" height="10" fill="#3b82f6" className="window" style={{'--window-index': 2}}/>
            <rect x="20" y="45" width="10" height="10" fill="#3b82f6" className="window" style={{'--window-index': 3}}/>
            <rect x="35" y="45" width="10" height="10" fill="#3b82f6" className="window" style={{'--window-index': 4}}/>
            <rect x="50" y="45" width="10" height="10" fill="#3b82f6" className="window" style={{'--window-index': 5}}/>
            <rect x="32" y="60" width="16" height="10" fill="#1e40af"/>
          </svg>
        </div>
        
        <h1 className="app-title">SRINIVASA FLATS</h1>
        <p className="app-subtitle">Community Management System</p>
        
        {/* Progress Bar */}
        <div className="progress-container">
          <div className="progress-bar-bg">
            <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
          </div>
          <span className="progress-text">{progress}%</span>
        </div>
        
        {/* Tips - FIXED ALIGNMENT */}
        <div className="loading-tip">
          <span className="tip-icon">💡</span>
          <span className="tip-text">{tips[currentTip]}</span>
        </div>
      </div>
      
      {/* Footer */}
      <div className="loading-footer">
        <div className="powered-by">
          <span>Powered by</span>
          <strong>STRONARIX</strong>
        </div>
        <p className="tagline">THE FUTURE IS TRAINED HERE</p>
      </div>
    </div>
  );
}

export default LoadingScreen;